import { render, staticRenderFns } from "./PostPartner.vue?vue&type=template&id=606b96ca&"
import script from "./PostPartner.vue?vue&type=script&lang=js&"
export * from "./PostPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports